export default {
    sc_setting_title: "Tarjeta Inteligente - Configuración",
    sc_setting_smart_card: "Tarjeta Inteligente",
    sc_setting_org_info: "Información de la Organización",
    sc_setting_form_popup: "Formulario Emergente",
    sc_setting_email_noti: "Notificación por Correo",
    sc_setting_sms_noti: "Notificación por SMS",
    sc_setting_autoresponder: "AutoRespondedor",
    sc_printlist_create: "Crear Nueva Tarjeta",
    sc_printlist_orginfo: "Información de la Organización",
    sc_printlist_employee_info: "Información del Empleado",
    sc_printlist_template: "Plantilla",
    sc_printlist_delete: "Eliminar",
    sc_printlist_edit_card: "Editar",
    sc_printlist_profile: "Perfil",
    sc_printlist_add: "+ Agregar",
    sc_printlist_new_card_title: "Nueva Tarjeta",
    sc_printlist_limit_title: "No se pueden generar más tarjetas.",
    sc_printlist_limit_text: "Se alcanzó el límite permitido. Por favor contacta a tu administrador en support@marketea.com o llámanos al 774-287-3353.",
    sc_printlist_swal_delete_title: "¿Eliminar Tarjeta?",
    sc_printlist_swal_delete_confirm: "¡Sí, elimínala!",
    sc_printlist_success: "Éxito",
    sc_printlist_removed: "¡Eliminada exitosamente!",
}
